import { createAction, props } from '@ngrx/store';
import { DatasetBrowserData, Pagination, PaginationTypes } from '@mode/shared/contract-common';

export const loadDatasetBrowserData = createAction(
  '[Dataset Search Import Modal] Load Dataset Browser Data',
  props<{ org: string; datasetType: string; pageNum: number; searchTerm: string; tabType: string }>()
);
export const loadDatasetDataWithSearch = createAction(
  '[Dataset Search Import Modal] Load Search Dataset',
  props<{ org: string; datasetType: string; pageNum: number; searchTerm: string; tabType: string }>()
);

export const loadDatasetBrowserDataSuccess = createAction(
  '[Datasets] Load Dataset Browser Data Success',
  props<{
    tabType: string;
    datasetBrowserData: DatasetBrowserData[];
    pagination: PaginationTypes.Pagination;
  }>()
);
export const loadDatasetBrowserDataFailure = createAction(
  '[Dataset Search Import Moadl] Failed to load dataset browser data'
);

export const updateWorkspaceSearchTerm = createAction(
  '[Datasets] Update Workspace Search Term',
  props<{ searchTerm: string }>()
);

export const updatePersonalSearchTerm = createAction(
  '[Datasets] Update personal Search Term',
  props<{ searchTerm: string }>()
);
